import React, { useState, useEffect } from 'react'
import {
  Table as MuiTable,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  TablePagination,
} from '@mui/material'
import Form from './Form'
import { LoadingSkeletonRows } from '../shared/LoadingSkeletonRows'
import ErrorMessage from '../../component/shared/component/ErrorMessage'
import Row from './Row'
import { useGetGmn, usePostGmn } from '../../api/gmn'

const Table = ({ open, setOpen, searchKey }) => {
  const [page, setPage] = useState(1)
  const [rowsPerPage, setRowsPerPage] = useState(10)

  const { data, isLoading, refetch, error } = useGetGmn({
    page: page + 1,
    limit: rowsPerPage,
    searchKey,
  })

  const handleChangePage = (event, newPage) => setPage(newPage)

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value)
    setPage(0)
  }

  useEffect(() => setPage(0), [searchKey])

  return (
    <Box>
      {error ? (
        <ErrorMessage error={error} onRetry={refetch} />
      ) : data?.docs?.length > 0 || isLoading ? (
        <>
          <TableContainer component={Paper}>
            <MuiTable>
              <TableHead>
                <TableRow>
                  <TableCell>Name</TableCell>
                  <TableCell>Bonus Tier 2 Tickets</TableCell>
                  <TableCell>Overrides</TableCell>
                  <TableCell>Last Edited By</TableCell>
                  <TableCell />
                  <TableCell />
                </TableRow>
              </TableHead>
              <TableBody>
                {isLoading ? (
                  <LoadingSkeletonRows rows={10} length={6} />
                ) : (
                  data.docs.map((row, index) => <Row data={row} key={index} refetch={refetch} />)
                )}
              </TableBody>
            </MuiTable>
          </TableContainer>
          {!isLoading && (
            <TablePagination
              component='div'
              count={data.totalDocs || 0}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          )}
        </>
      ) : (
        <ErrorMessage empty />
      )}
      <Form open={open} setOpen={setOpen} api={usePostGmn} refetch={refetch} />
    </Box>
  )
}

export default Table
